import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-steel text-white py-10 px-4" data-id="element-318">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-319">
        <div className="flex flex-col items-center justify-center" data-id="element-320">
          <UsersIcon className="w-10 h-10 text-brand-amber mb-3" data-id="element-321" />
          <span className="text-3xl font-black mb-1" data-id="element-322">+2.000</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-323">
            personas
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-324">
          <BookOpenIcon className="w-10 h-10 text-brand-amber mb-3" data-id="element-325" />
          <span className="text-3xl font-black mb-1" data-id="element-326">5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-327">
            Tomos Maestros
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-328">
          <div className="flex text-brand-forge mb-3" data-id="element-329">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-330" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-331" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-332" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-333" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-334" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-335">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-336">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-337">
          <MapPinIcon className="w-10 h-10 text-brand-amber mb-3" data-id="element-338" />
          <span className="text-3xl font-black mb-1" data-id="element-339">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-340">
            Todo el país
          </span>
        </div>
      </div>
    </section>;
}